<template>
    <div class="container wysiwig-wrapper detail-container">
        <section class="padded">
            <div class="event-details">
                <div class="split-header">
                    <router-link class="return-link" :to="{ name: 'eventListing' }">&lt; <p>Back to Events</p></router-link>
                    <div class="event-name" v-bind:class="{'noimage' : event.image === ''}">
                        <router-link class="mobile-return-link" :to="{ name: 'eventListing' }">&lt; <p>Back to Events</p></router-link>
                        <h1 class="h2">{{event.name}}</h1>
                    </div>
                    <div class="event-image" v-bind:class="{'noimage' : event.image === ''}">
                        <img v-if="event.image" v-bind:src="event.image" v-bind:alt="event.name">
                    </div>
                </div>

                <div class="event-stats">
                    <div class="stat">
                        <p><strong>Date:</strong></p>
                        <p>{{ parsedStartDate }}</p>
                        <p v-if="(parsedEndDate !== '' && parsedEndDate != parsedStartDate)">to {{ parsedEndDate }}</p>
                    </div>
                    <div class="stat">
                        <p><strong>Time:</strong></p>
                        <p>{{ event.startTime }}</p>
                        <p v-if="event.endTime">to {{event.endTime}}</p>
                    </div>
                    <div class="stat">
                        <p><strong>Location:</strong></p>
                        <p>{{ event.eventStoreLocation }}</p>
                        <p>{{event.eventAddress}}</p>
                    </div>
                </div>

                <div class="event-description" v-html="event.description"></div>

                <a class="btn" v-if="event.eventBrightUrl !== ''" v-bind:href="event.eventBrightUrl" target="_blank">Get Tickets</a>
            </div>
        </section>
    </div>
</template>

<style lang="scss" scoped>
    @import "../scss/_variables";

    .detail-container {
        padding-top: 0px !important;
    }


    .split-header {
        display: flex;
        position: relative;

        @media(max-width: 767px) {
            flex-direction: column-reverse;
        }

        .return-link {
            position: absolute;
            left: 0px;
            top: 30px;


            @media(max-width: 767px) {
                display: none;
            }

            p {
                display: inline;
            }
        }

        .event-name {
            width: 35%;
            padding: 30px 30px 0px 15px;
            display: flex;
            flex-direction: column;
            justify-content: center;

            @media(max-width: 767px) {
                width: 100%;
                padding: 30px 0px 0px 0px;
            }

            .mobile-return-link {
                display: none;

                @media(max-width: 767px) {
                    display: inline-block;
                }

                p {
                    display: inline;
                }

            }

            &.noimage {
                width: 50%;

                @media(max-width: 767px) {
                    width: 100%;
                }
            }

            a {
                color: $c-black;
                display: inline-block;
            }

            .return-link {
                text-decoration: underline;
                color: $c-black;
                display: inline;
            }

            .h2, .h1 {
                letter-spacing: unset;
                text-transform: none;
                margin-top: 30px;
            }
        }

        .event-image {
            width: 65%;

            @media(max-width: 767px) {
                width: 100%;
            }

            &.noimage {
                width: 50%;
                @media(max-width: 767px) {
                    width: 100%;
                }
            }

            img {
                width: 100%;
            }
        }
    }

    .event-stats {
        display: flex;

        @media(max-width: 767px) {
            flex-direction: column;
        }

        .stat {
            padding: 60px 15px;
            padding-left: 25px;
            width: 33%;

            &:first-of-type {
                padding-left: 0px;
            }

            @media(max-width: 767px) {
                padding: 15px;
                padding-left: 0px;
                width: 100%;
            }

            p {
                font-size: 18px;

                strong {
                    font-weight: bold;
                }
            }
        }
    }

    .store-location {
        text-transform: uppercase;
    }

    .event-description {
        margin-bottom: 60px;
        margin-top: 30px;
    }

    .btn {
        border-color: #000;
    }
</style>


<script>
    export default {
        data() {
            return {
                event: null,
                parsedStartDate: '',
                parsedEndDate: '',
                monthNames: {
                    1: 'January',
                    2: 'February',
                    3: 'March',
                    4: 'April',
                    5: 'May',
                    6: 'June',
                    7: 'July',
                    8: 'August',
                    9: 'September',
                    10: 'October',
                    11: 'November',
                    12: 'December'
                }
            }
        },
        computed: {
            parsedDescription() {
                const doc = new DOMParser().parseFromString(this.event.description, "text/html");
                return doc.documentElement.textContent;
            }
        },
        created() {
            $('#events-featured-image-parent').hide();
            this.$nextTick(() => {
                $('html').scrollTop(0);
            });

            const events = this.$parent.events; // not recommended to use this.$parent, but we're never really changing state so it's ok
            this.event = events.find((item) => item.slug === this.$route.params.slug);
            this.parsedStartDate = this.parseStartDate(this.event);
            this.parsedEndDate = this.parseEndDate(this.event);
        },
        methods: {
            parseStartDate: function (event) {

                //refactor to account for comma
                return `${this.getMonthName(event.startDateMonth)} ${event.startDateDay}, ${event.startDateYear}`;
            },
            parseEndDate: function (event) {

                // refactor to account for comma
                return `${this.getMonthName(event.endDateMonth)} ${event.endDateDay}, ${event.endDateYear}`;
            },
            getMonthName: function (name) {
                if (name !== '') {
                    const month = parseInt(name);
                    if (Number.isInteger(month)) {
                        return this.monthNames[month];
                    } else {
                        '';
                    }
                } else {
                    return '';
                }
            }
        }
    }
</script>
